<template>
    <aside class="remodal">
        <button data-remodal-action="close" class="remodal-close">
            <i class="material-icons">close</i>
        </button>

        <div class="profile profile--vertical mb--20">
            <figure class="profile__avatar">
                <span class="profile__avatar__img">
                    <img :src="user.avatar" alt="" />
                </span>
            </figure>
        </div>


        <h4 class="modal__title">
            {{ user.nick }}
        </h4>

        <div class="mb--30">
            <p>Change your level</p>

            <select v-model="level" class="form-control form-control--dark mb--md">
                <option value="1">Level 1</option>
                <option value="2">Level 2</option>
                <option value="3">Level 3</option>
                <option value="4">Level 4</option>
            </select>
        </div>
        <a @click="updateLevel" class="btn btn--block btn--secondary">Done</a>
    </aside>
</template>

<script>
    import {mapGetters} from "vuex";

    export default {
        name: "LevelSelectorModal",
        computed: {
            ...mapGetters('auth', [
                'user',
                'isLoggedIn'
            ]),
        },
        data: () => ({
            instance: null,
            level: null
        }),

        mounted() {
            this.instance = $(this.$el).remodal({
                hashTracking: false
            });

            this.level = this.$store.state.auth.user.level;
        },

        methods: {
            close() {
                this.instance.close()
            },

            open() {
                this.instance.open()
            },
            updateLevel() {
                Quiz.$emit('update-user-level', this.level)
                this.close();
            }
        },
    }
</script>